/* Y2K Theme — Front-end interactions */

(function () {
  'use strict';

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var delta = parseInt(btn.dataset.qty, 10);
    var min = parseInt(input.min, 10) || 1;
    var next = Math.max(min, (parseInt(input.value, 10) || 1) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant picker with sold-out detection ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = form ? form.querySelector('[type="submit"]') : null;
    var variantsScript = document.querySelector('[data-variants-json]');
    var variants = [];
    try { if (variantsScript) variants = JSON.parse(variantsScript.textContent); } catch (e) {}

    function getSelectedOptions() {
      var chosen = [];
      picker.querySelectorAll('.variant-group').forEach(function (g) {
        var active = g.querySelector('.variant-option.is-active');
        if (active) chosen.push(active.dataset.value);
      });
      return chosen;
    }

    function updateSoldOutStates() {
      var chosen = getSelectedOptions();
      picker.querySelectorAll('.variant-group').forEach(function (g, groupIdx) {
        g.querySelectorAll('.variant-option').forEach(function (btn) {
          var testOptions = chosen.slice();
          testOptions[groupIdx] = btn.dataset.value;
          var match = variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === testOptions[i]; });
          });
          var soldOut = match && !match.available;
          btn.classList.toggle('is-sold-out', soldOut);
          btn.disabled = soldOut;
        });
      });
    }

    picker.addEventListener('click', function (e) {
      var btn = e.target.closest('.variant-option');
      if (!btn || btn.disabled) return;

      var group = btn.closest('.variant-group');
      group.querySelectorAll('.variant-option').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      var chosen = getSelectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      if (match) {
        if (variantInput) variantInput.value = match.id;
        if (priceEl && match.price != null) priceEl.textContent = formatMoney(match.price);
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'Add to cart ✦' : 'Sold out';
        }
      }
      updateSoldOutStates();
    });

    updateSoldOutStates();
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var originalLabel = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateShippingProgress(cart.total_price);
        if (btn) { btn.textContent = '✓ Added!'; }
        setTimeout(function () {
          if (btn && originalLabel) { btn.textContent = originalLabel; btn.disabled = false; }
        }, 1500);
      })
      .catch(function () {
        if (btn && originalLabel) { btn.textContent = originalLabel; btn.disabled = false; }
        alert('Something went wrong — try again?');
      });
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ---------- Free shipping progress bar ---------- */
  var FREE_SHIPPING_THRESHOLD = 7500; // $75 in cents

  function updateShippingProgress(totalCents) {
    var bar = document.querySelector('[data-shipping-fill]');
    var label = document.querySelector('[data-shipping-label]');
    var wrapper = document.querySelector('.shipping-progress');
    if (!bar || !label) return;

    if (totalCents >= FREE_SHIPPING_THRESHOLD) {
      bar.style.width = '100%';
      label.innerHTML = '🎉 You\'ve unlocked <strong>free US shipping!</strong>';
      if (wrapper) wrapper.classList.add('shipping-progress--complete');
    } else {
      var remaining = ((FREE_SHIPPING_THRESHOLD - totalCents) / 100).toFixed(2);
      var pct = Math.min(100, (totalCents / FREE_SHIPPING_THRESHOLD) * 100).toFixed(0);
      bar.style.width = pct + '%';
      label.innerHTML = 'Add <strong>$' + remaining + '</strong> more for free US shipping';
      if (wrapper) wrapper.classList.remove('shipping-progress--complete');
    }
  }

  // Init on cart page
  var initialFill = document.querySelector('[data-shipping-fill]');
  if (initialFill) {
    var cartTotalEl = document.querySelector('[data-cart-total-cents]');
    if (cartTotalEl) updateShippingProgress(parseInt(cartTotalEl.dataset.cartTotalCents, 10));
  }

  /* ---------- Money formatter ---------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Sparkle effect on product card hover ---------- */
  function spawnSparkle(card) {
    var sparkle = document.createElement('span');
    var size = Math.random() * 10 + 8;
    sparkle.style.cssText = [
      'position:absolute',
      'pointer-events:none',
      'width:' + size + 'px',
      'height:' + size + 'px',
      'top:' + (Math.random() * 80 + 5) + '%',
      'left:' + (Math.random() * 80 + 5) + '%',
      'background:var(--pink)',
      'border-radius:50%',
      'opacity:0.7',
      'z-index:3',
      'animation:sparkle-pop 0.5s ease forwards'
    ].join(';');
    card.style.position = 'relative';
    card.appendChild(sparkle);
    setTimeout(function () { sparkle.remove(); }, 500);
  }

  if (!document.querySelector('#sparkle-keyframes')) {
    var style = document.createElement('style');
    style.id = 'sparkle-keyframes';
    style.textContent = '@keyframes sparkle-pop{0%{transform:scale(0);opacity:.7}60%{transform:scale(1.4);opacity:.5}100%{transform:scale(0);opacity:0}}';
    document.head.appendChild(style);
  }

  document.querySelectorAll('.product-card').forEach(function (card) {
    card.addEventListener('mouseenter', function () { spawnSparkle(card); });
  });

  /* ---------- Countdown timer ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) return;
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { el.textContent = 'ENDED'; return; }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Mobile drawer ---------- */
  var menuBtn = document.querySelector('.mobile-menu-btn');
  var drawer = document.getElementById('mobile-drawer');
  var drawerClose = drawer && drawer.querySelector('.mobile-drawer__close');
  var drawerOverlay = drawer && drawer.querySelector('.mobile-drawer__overlay');
  var focusableSelectors = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var firstFocusable = drawer.querySelector(focusableSelectors);
    if (firstFocusable) firstFocusable.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (menuBtn) { menuBtn.setAttribute('aria-expanded', 'false'); menuBtn.focus(); }
    document.body.style.overflow = '';
  }

  if (drawer) {
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = Array.from(drawer.querySelectorAll(focusableSelectors));
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  if (menuBtn) menuBtn.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Tab switching ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var btns = root.querySelectorAll('.tabs__btn');
    var panels = root.querySelectorAll('.tab-panel');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.tab;
        btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === target); });
      });
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  var galleryMain = document.querySelector('[data-main-image] img');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (galleryMain) galleryMain.src = thumb.dataset.thumb;
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var stickyAdd = document.querySelector('[data-sticky-add]');
  if (stickyAdd) {
    stickyAdd.addEventListener('click', function () {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });
  }
  if (stickyBar) {
    var atcAnchor = document.querySelector('form[action*="/cart/add"] [type="submit"]');
    if (atcAnchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        // Show the sticky bar only once the main Add-to-cart has scrolled out of view
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(atcAnchor);
    }
  }

  /* ---------- Collection sort ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

})();
